/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Grid, Card, CardMedia } from '@mui/material';
const getDominantColor = async (imgSrc: string): Promise<string> =>
{
	const image = new Image();

	image.crossOrigin = 'Anonymous';
	image.src = imgSrc;

	return new Promise((resolve, reject) =>
	{
		image.onload = () =>
		{
			const canvas = document.createElement('canvas');

			canvas.width = image.width;
			canvas.height = image.height;
			const ctx = canvas.getContext('2d');

			if (!ctx)
			{
				reject(new Error('Could not get canvas context'));

				return;
			}

			ctx.drawImage(image, 0, 0);
			const { data } = ctx.getImageData(0, 0, image.width, image.height);

			let r = 0; let g = 0; let b = 0; let count = 0;

			for (let i = 0; i < data.length; i += 4)
			{
				r += data[i];
				g += data[i + 1];
				b += data[i + 2];
				count++;
			}

			r = Math.round(r / count);
			g = Math.round(g / count);
			b = Math.round(b / count);

			resolve(`rgb(${r}, ${g}, ${b})`);
		};

		image.onerror = () =>
		{
			reject(new Error('Error loading image'));
		};
	});
};

const ImageBgView = ({ imgSrc, caption }: { imgSrc: string; caption: string }) =>
{
	useEffect(() =>
	{
		const updateBgColor = async () =>
		{
			try
			{
				await getDominantColor(imgSrc);
			}
			catch (error)
			{
				console.error(error);
			}
		};

		updateBgColor();
	}, [ imgSrc ]);

	// Inline styles

	const cardStyle = {
		transition   : 'background-color 1s linear',
		boxShadow    : '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
		borderRadius : '8px 8px 0px 0px',
		// backgroundColor : bgColor,
		width        : 'var(--percent100)',
		height       : 'var(--percent100)'
	};

	const mediaStyle = {
		height : 'var(--percent100)',
		width  : 'var(--percent100)'
	};

	return (
		<Grid item height={'225px'}>
			<Card style={cardStyle}>
				<CardMedia
					component='img'
					image={imgSrc}
					alt='slide'
					style={mediaStyle}
				/>
			</Card>
		</Grid>
	);
};

export default ImageBgView;